/* eslint-disable */
export default {
  matched: 'Coincidencia',
  other: 'Otro',
  associated: 'Asociado',
  foundFromServer: 'Resultados de {appName}',
  recently: 'Recientes',
  additionalLabelAccount: 'Cuenta: {displayName}',
  additionalLabelContact: 'Contacto: {displayName}',
  notFound: 'No disponible',
} as const;

// @key: @#@"matched"@#@ @source: @#@"Matched"@#@
// @key: @#@"other"@#@ @source: @#@"Other"@#@
// @key: @#@"associated"@#@ @source: @#@"Associated"@#@
// @key: @#@"foundFromServer"@#@ @source: @#@"Found from {appName}"@#@
// @key: @#@"recently"@#@ @source: @#@"Recent"@#@
// @key: @#@"additionalLabelAccount"@#@ @source: @#@"Account: {displayName}"@#@
// @key: @#@"additionalLabelContact"@#@ @source: @#@"Contact: {displayName}"@#@
// @key: @#@"notFound"@#@ @source: @#@"N/A"@#@
